var _g, _line, _path, _polygon, _polygon2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnPlatformIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1,
    y: 1.5,
    width: 46,
    height: 45
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#231F20",
    d: "M46.008,24.008v0.289c-0.027,1.961-0.289,3.922-0.844,5.813 c-0.508,1.902-1.297,3.711-2.316,5.398c-0.996,1.699-2.223,3.258-3.648,4.609c-1.391,1.383-2.98,2.566-4.691,3.52 c-1.711,0.969-3.547,1.699-5.465,2.168c-1.891,0.5-3.867,0.734-5.828,0.691c-1.973,0-3.934-0.289-5.813-0.84 c-1.906-0.512-3.711-1.301-5.394-2.32c-1.699-0.98-3.258-2.211-4.613-3.633c-1.379-1.395-2.567-2.98-3.52-4.707 c-0.965-1.711-1.715-3.547-2.184-5.453c-0.496-1.906-0.714-3.867-0.687-5.84c0.012-1.961,0.305-3.922,0.844-5.813 C2.371,16,3.156,14.176,4.164,12.496c0.992-1.688,2.223-3.246,3.645-4.613c1.394-1.383,2.98-2.567,4.707-3.508 c1.699-0.98,3.55-1.711,5.453-2.18c1.906-0.496,3.863-0.73,5.824-0.691c1.977,0.016,3.938,0.293,5.828,0.844 c1.891,0.523,3.711,1.297,5.383,2.316c1.699,0.996,3.258,2.227,4.625,3.633c1.383,1.406,2.566,2.996,3.508,4.707 c0.98,1.715,1.711,3.551,2.18,5.465C45.789,20.266,46.035,22.141,46.008,24.008"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.9971,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 11.559,
    y1: 31.836,
    x2: 34.812,
    y2: 31.836
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M35.902,31.836c0,1.273-1.031,2.305-2.301,2.305c-1.273,0-2.305-1.031-2.305-2.305 c0-1.27,1.031-2.301,2.305-2.301C34.871,29.535,35.902,30.566,35.902,31.836z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "25.863,14.285 33.418,20.086 25.863,25.887 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.8756,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    points: "25.863,14.285  33.418,20.086 25.863,25.887 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.664,
    y: 17.852,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    width: 11.707,
    height: 4.474
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.664,
    y: 17.852,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 0.7723,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    width: 11.707,
    height: 4.474
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPlatformIn);
export default __webpack_public_path__ + "static/media/btnPlatformIn.40d83ce91f69d0b9d387f72cd5322825.svg";
export { ForwardRef as ReactComponent };